/* Native home floating stories, Lookbook/Saved Trend and Look Detail surfaces.
   Editorial content is public and live. Only the signed-in owner's saved_trends
   and saved_looks rows can be changed. */

(function () {
  var SESSION_KEY = 'gettmi:session:v1';
  var LOOKBOOK_STATS = [
    { likes: '32.1K', comments: '19', saves: '2.3K' },
    { likes: '18.4K', comments: '12', saves: '1.6K' },
    { likes: '24.7K', comments: '20', saves: '3.1K' },
    { likes: '9.8K', comments: '7', saves: '986' },
    { likes: '41.2K', comments: '15', saves: '4.8K' },
    { likes: '13.6K', comments: '5', saves: '1.1K' },
    { likes: '27.9K', comments: '10', saves: '2.7K' },
    { likes: '15.3K', comments: '9', saves: '1.4K' }
  ];
  var COMMENTS = [
    { author: 'Maya Ellis', text: 'Wait this outfit is actually insane 😭', likes: '459' },
    { author: 'GETTMI', text: 'This edit is about sharp proportions, clean layers, and pieces that make the outfit feel intentional.', likes: '138', reply: true },
    { author: 'LivStyles', text: 'The little fitted layer underneath is carryinggg.', likes: '193' },
    { author: 'Amara Collins', text: 'This is the kind of inspo I need before I start panic buying.', likes: '76' },
    { author: 'Talia Rose', text: 'The colours are giving rich girl without trying.', likes: '221' }
  ];
  var state = {
    featured: null,
    featuredImages: [],
    featuredImageIndex: 0,
    featuredLoadId: 0,
    featuredProduct: null,
    likedLook: false,
    likedSlides: [],
    ownerLoadId: 0,
    primaryFeatured: null,
    primaryFeaturedProduct: null,
    lastLookbookTapAt: 0,
    lastLookbookTapSlide: -1,
    lookbookGateIndex: null,
    lookbookGateOpener: null,
    lookbookGateTouchStart: null,
    lookbookHistoryPushed: false,
    ignoreNextLookbookPop: false,
    lookbookTouchStart: null,
    savedLook: false,
    savedTrends: [],
    slideIndex: 0,
    slides: [],
    suppressLookbookClickUntil: 0,
    returnToFavourites: false
  };

  function root() {
    return document.querySelector('[data-gettmi-editorial-surfaces]');
  }

  function config() {
    var node = document.querySelector('[data-gettmi-supabase]');
    return node ? { url: node.dataset.supabaseUrl, key: node.dataset.supabaseKey } : null;
  }

  function session() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function savesGated() {
    return Boolean(
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.isEnabled === 'function' &&
      window.GettmiAppGate.isEnabled('save_look')
    );
  }

  function lookbookGated() {
    return Boolean(
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.isEnabled === 'function' &&
      window.GettmiAppGate.isEnabled('lookbook')
    );
  }

  function lookbookOpenSlides() {
    var mount = root();
    var configured = Number(mount && mount.dataset.gettmiLookbookOpenSlides || 3);
    return Math.max(1, Math.min(4, Number.isFinite(configured) ? configured : 3));
  }

  function authHeaders(currentSession, extra) {
    var cfg = config();
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + currentSession.access_token
    }, extra || {});
  }

  function publicUrl(cfg, row, imagePath, width, height) {
    var version = row.metadata && row.metadata.asset_version || row.updated_at || row.id || '';
    var path = String(imagePath || row.image_path || '').split('/').map(encodeURIComponent).join('/');
    var params = [
      'width=' + encodeURIComponent(width || 1200),
      'quality=72',
      'resize=cover'
    ];
    if (height) params.splice(1, 0, 'height=' + encodeURIComponent(height));
    if (version) params.push('v=' + encodeURIComponent(version));
    return cfg.url + '/storage/v1/render/image/public/' +
      encodeURIComponent(row.bucket) + '/' + path + '?' + params.join('&');
  }

  // The native app's lookbook uses Supabase getPublicUrl(), not an image
  // transform. A width-only `resize=cover` transform preserves the source
  // height and crops the sides before CSS `object-fit: contain` ever sees it.
  // Use the original public asset for the full editorial slide; the bounded
  // square transform remains correct for the small floating-story disc.
  function publicOriginalUrl(cfg, row, imagePath) {
    var version = row.metadata && row.metadata.asset_version || row.updated_at || row.id || '';
    var path = String(imagePath || row.image_path || '').split('/').map(encodeURIComponent).join('/');
    return cfg.url + '/storage/v1/object/public/' +
      encodeURIComponent(row.bucket) + '/' + path +
      (version ? '?v=' + encodeURIComponent(version) : '');
  }

  function syncFloatingStoryVisibility() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    var opacity = Math.max(0, Math.min(1, 1 - Math.max(0, scrollTop - 210) / 42));
    document.querySelectorAll('[data-gettmi-floating-stories], [data-gettmi-second-banner-feature]').forEach(function (node) {
      node.style.setProperty('--gettmi-floating-story-opacity', String(opacity));
      node.classList.toggle('is-scroll-hidden', scrollTop >= 252);
    });
  }

  function scheduleFloatingStoryVisibility() {
    if (scheduleFloatingStoryVisibility.frame) return;
    scheduleFloatingStoryVisibility.frame = window.requestAnimationFrame(function () {
      scheduleFloatingStoryVisibility.frame = 0;
      syncFloatingStoryVisibility();
    });
  }

  function setText(selector, value) {
    var mount = root();
    var node = mount && mount.querySelector(selector);
    if (node) node.textContent = String(value || '');
  }

  function showToast(message) {
    var mount = root();
    if (!mount) return;
    var toast = mount.querySelector('[data-gettmi-editorial-toast]');
    toast.textContent = message || '';
    toast.hidden = !message;
    window.clearTimeout(showToast.timer);
    if (message) showToast.timer = window.setTimeout(function () { toast.hidden = true; }, 1800);
  }

  function lock(open) {
    document.documentElement.classList.toggle('gettmi-editorial-overlay-open', Boolean(open));
  }

  function requestLookbookLandscape() {
    var orientation = window.screen && window.screen.orientation;
    if (!orientation || typeof orientation.lock !== 'function') return;
    try {
      Promise.resolve(orientation.lock('landscape')).catch(function () {
        /* CSS rotates the full-view shell when browser locking is unavailable. */
      });
    } catch (error) {
      /* CSS rotation remains the cross-browser fallback. */
    }
  }

  function releaseLookbookLandscape() {
    var orientation = window.screen && window.screen.orientation;
    if (!orientation || typeof orientation.unlock !== 'function') return;
    try {
      orientation.unlock();
    } catch (error) {
      /* The CSS shell returns to portrait even when browser unlock is unavailable. */
    }
  }

  function lookbookGateIsOpen() {
    var mount = root();
    var gate = mount && mount.querySelector('[data-gettmi-lookbook-gate]');
    return Boolean(gate && !gate.hidden);
  }

  function pushLookbookHistory() {
    if (state.lookbookHistoryPushed) return;
    window.history.pushState({ gettmiLookbook: true }, '', window.location.href);
    state.lookbookHistoryPushed = true;
  }

  function syncLookbookGateDestination() {
    var mount = root();
    var store = mount && mount.querySelector('[data-gettmi-lookbook-gate-store]');
    if (!store) return false;
    var destination =
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.destination === 'function'
        ? window.GettmiAppGate.destination('lookbook')
        : '';
    store.href = destination || '#';
    store.setAttribute('aria-disabled', String(!destination));
    store.dataset.destinationAvailable = String(Boolean(destination));
    if (destination) store.removeAttribute('tabindex');
    else store.setAttribute('tabindex', '-1');
    return Boolean(destination);
  }

  function recordLookbookGate(action) {
    if (
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.record === 'function'
    ) {
      window.GettmiAppGate.record(action, 'lookbook', 'lookbook_slide');
    }
  }

  function hideLookbookGate(returnFocus) {
    var mount = root();
    var gate = mount && mount.querySelector('[data-gettmi-lookbook-gate]');
    var viewer = mount && mount.querySelector('.gettmi-lookbook__viewer');
    if (!gate || gate.hidden) return;
    gate.hidden = true;
    var lookbook = mount.querySelector('[data-gettmi-lookbook]');
    if (lookbook) lookbook.classList.remove('is-gated');
    if (viewer) {
      viewer.inert = false;
      viewer.removeAttribute('aria-hidden');
    }
    state.lookbookGateIndex = null;
    var opener = state.lookbookGateOpener;
    state.lookbookGateOpener = null;
    if (returnFocus && opener && document.contains(opener)) {
      opener.focus({ preventScroll: true });
    }
  }

  function showLookbookGate(index, opener) {
    var mount = root();
    var gate = mount && mount.querySelector('[data-gettmi-lookbook-gate]');
    var viewer = mount && mount.querySelector('.gettmi-lookbook__viewer');
    var slide = state.slides[index];
    if (!gate || !viewer || !slide || !lookbookGated()) return false;
    state.lookbookGateIndex = index;
    state.lookbookGateOpener = opener || document.activeElement;
    setText(
      '[data-gettmi-lookbook-gate-label]',
      'SLIDE ' + (index + 1) + ' OF ' + state.slides.length
    );
    mount.querySelectorAll('[data-gettmi-lookbook-gate-image]').forEach(function (image) {
      image.src = slide.url;
    });
    var fullView = mount.querySelector('[data-gettmi-lookbook-full]');
    fullView.hidden = true;
    fullView.classList.remove('is-opening');
    releaseLookbookLandscape();
    viewer.inert = true;
    viewer.setAttribute('aria-hidden', 'true');
    mount.querySelector('[data-gettmi-lookbook]').classList.add('is-gated');
    gate.hidden = false;
    syncLookbookGateDestination();
    recordLookbookGate('view');
    window.requestAnimationFrame(function () {
      gate.focus({ preventScroll: true });
    });
    return true;
  }

  function closeAll() {
    var mount = root();
    if (!mount) return;
    hideLookbookGate(false);
    mount.querySelectorAll('.gettmi-lookbook, .gettmi-lookbook-full, .gettmi-look-detail, .gettmi-comment-sheet').forEach(function (node) {
      node.hidden = true;
    });
    releaseLookbookLandscape();
    lock(false);
  }

  function openSavedTrend(index, returnToFavourites) {
    var mount = root();
    var parsedIndex = Number(index);
    if (!mount || !state.slides.length || !Number.isFinite(parsedIndex)) return;
    var requestedIndex = Math.max(0, Math.min(state.slides.length - 1, parsedIndex));
    var openSlides = Math.min(lookbookOpenSlides(), state.slides.length);
    state.slideIndex =
      lookbookGated() && requestedIndex >= openSlides
        ? Math.max(0, openSlides - 1)
        : requestedIndex;
    state.returnToFavourites = Boolean(returnToFavourites);
    mount.querySelector('[data-gettmi-lookbook]').hidden = false;
    lock(true);
    pushLookbookHistory();
    renderLookbook();
    if (lookbookGated() && requestedIndex >= openSlides) {
      showLookbookGate(requestedIndex, null);
    }
  }

  function closeLookbook(fromPop) {
    var returnToFavourites = state.returnToFavourites;
    state.returnToFavourites = false;
    closeAll();
    if (state.lookbookHistoryPushed && !fromPop) {
      state.ignoreNextLookbookPop = true;
      window.history.back();
    }
    state.lookbookHistoryPushed = false;
    if (returnToFavourites) {
      document.dispatchEvent(new CustomEvent('gettmi:saved-trend-closed'));
    }
  }

  function renderLookbook() {
    var mount = root();
    if (!mount || !state.slides.length) return;
    var slide = state.slides[state.slideIndex % state.slides.length];
    var stats = LOOKBOOK_STATS[state.slideIndex] || LOOKBOOK_STATS[0];
    mount.querySelector('[data-gettmi-lookbook-image]').src = slide.url;
    mount.querySelector('[data-gettmi-lookbook-image]').alt = slide.title || 'GETTMI lookbook';
    mount.querySelector('[data-gettmi-lookbook-full-image]').src = slide.url;
    mount.querySelector('[data-gettmi-lookbook-full-image]').alt = slide.title || 'GETTMI lookbook';
    setText('[data-gettmi-lookbook-counter]', (state.slideIndex + 1) + '/' + state.slides.length);
    setText('[data-gettmi-lookbook-full-counter]', (state.slideIndex + 1) + '/' + state.slides.length);
    setText('[data-gettmi-lookbook-likes]', stats.likes);
    setText('[data-gettmi-lookbook-comments]', stats.comments);
    setText('[data-gettmi-lookbook-saves]', stats.saves);
    setText('[data-gettmi-lookbook-like-icon]', state.likedSlides.indexOf(state.slideIndex) === -1 ? '♡' : '♥');
    var save = mount.querySelector('[data-gettmi-lookbook-save]');
    save.classList.toggle('is-active', state.savedTrends.indexOf(state.slideIndex) !== -1);
  }

  function showLookbookHeartBurst(frame, event) {
    var rect = frame.getBoundingClientRect();
    var originX = event && Number.isFinite(event.clientX) ? event.clientX - rect.left : rect.width * 0.5;
    var originY = event && Number.isFinite(event.clientY) ? event.clientY - rect.top : rect.height * 0.44;
    var bursts = [
      { x: -30, rise: 92, rotate: -18 },
      { x: -12, rise: 126, rotate: -8 },
      { x: 8, rise: 108, rotate: 7 },
      { x: 28, rise: 138, rotate: 16 },
      { x: 42, rise: 88, rotate: 22 }
    ];
    bursts.forEach(function (burst, index) {
      var heart = document.createElement('span');
      heart.className = 'gettmi-lookbook__heart-burst';
      heart.textContent = '♥';
      heart.style.setProperty('--gettmi-heart-x', originX + 'px');
      heart.style.setProperty('--gettmi-heart-y', originY + 'px');
      heart.style.setProperty('--gettmi-heart-drift-x', burst.x + 'px');
      heart.style.setProperty('--gettmi-heart-rise', burst.rise + 'px');
      heart.style.setProperty('--gettmi-heart-rotate', burst.rotate + 'deg');
      heart.style.animationDelay = (index * 28) + 'ms';
      frame.appendChild(heart);
      window.setTimeout(function () { heart.remove(); }, 1100);
    });
  }

  function setLookbookLike(liked, showMessage, event) {
    var wasLiked = state.likedSlides.indexOf(state.slideIndex) !== -1;
    state.likedSlides = liked
      ? (wasLiked ? state.likedSlides : state.likedSlides.concat(state.slideIndex))
      : state.likedSlides.filter(function (index) { return index !== state.slideIndex; });
    renderLookbook();
    if (liked && !wasLiked) {
      var mount = root();
      var frame = mount && mount.querySelector('[data-gettmi-lookbook-like]');
      if (frame) showLookbookHeartBurst(frame, event);
    }
    if (showMessage) showToast(liked ? 'Liked this slide' : 'Removed like');
  }

  function handleLookbookImageTap(event) {
    var now = Date.now();
    if (now < state.suppressLookbookClickUntil) return;
    if (
      state.lastLookbookTapSlide === state.slideIndex &&
      now - state.lastLookbookTapAt <= 280
    ) {
      state.lastLookbookTapAt = 0;
      state.lastLookbookTapSlide = -1;
      setLookbookLike(true, false, event);
      return;
    }
    state.lastLookbookTapAt = now;
    state.lastLookbookTapSlide = state.slideIndex;
  }

  function stepLookbook(direction, opener) {
    if (!state.slides.length) return;
    if (lookbookGateIsOpen()) {
      if (direction < 0) hideLookbookGate(true);
      return;
    }
    if (!lookbookGated()) {
      state.slideIndex = (state.slideIndex + direction + state.slides.length) % state.slides.length;
    } else {
      var openSlides = Math.min(lookbookOpenSlides(), state.slides.length);
      if (direction < 0 && state.slideIndex === 0) return;
      var target = state.slideIndex + direction;
      if (target >= openSlides) {
        showLookbookGate(Math.min(target, state.slides.length - 1), opener);
        return;
      }
      state.slideIndex = Math.max(0, target);
    }
    state.lastLookbookTapAt = 0;
    state.lastLookbookTapSlide = -1;
    renderLookbook();
  }

  function featuredLookKey() {
    var meta = state.featured && state.featured.metadata || {};
    if (meta.post_id) return meta.post_id;
    if (state.featured && state.featured.surface === 'featured-product') return 'featured-product';
    return [
      state.featured && state.featured.surface || 'featured-look',
      state.featured && (state.featured.id || state.featured.link_path) || 'current'
    ].join(':');
  }

  function ownerRead() {
    var cfg = config();
    var currentSession = session();
    state.ownerLoadId += 1;
    var loadId = state.ownerLoadId;
    state.savedTrends = [];
    state.savedLook = false;
    renderLookbook();
    renderFeaturedActions();
    if (!cfg || !currentSession || !currentSession.user_id) return;
    var trendRequest = window.fetch(
      cfg.url + '/rest/v1/saved_trends?select=trend_key&user_id=eq.' + encodeURIComponent(currentSession.user_id),
      { headers: authHeaders(currentSession) }
    ).then(function (response) { return response.ok ? response.json() : []; });
    var lookKey = featuredLookKey();
    var lookRequest = window.fetch(
      cfg.url + '/rest/v1/saved_looks?select=look_key&user_id=eq.' + encodeURIComponent(currentSession.user_id) +
        '&look_key=eq.' + encodeURIComponent(lookKey),
      { headers: authHeaders(currentSession) }
    ).then(function (response) { return response.ok ? response.json() : []; });
    Promise.all([trendRequest, lookRequest]).then(function (results) {
      var latest = session();
      if (loadId !== state.ownerLoadId || !latest || latest.user_id !== currentSession.user_id) return;
      state.savedTrends = (results[0] || []).map(function (row) {
        var match = String(row.trend_key || '').match(/^lookbook-(\d+)$/);
        return match ? Number(match[1]) : null;
      }).filter(function (index) { return index !== null; });
      state.savedLook = Boolean(results[1] && results[1].length);
      renderLookbook();
      renderFeaturedActions();
    }).catch(function () {
      /* Owner rows remain empty until the consolidated authenticated test. */
    });
  }

  function toggleTrendSave() {
    if (savesGated()) return;
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id) {
      showToast('Sign in from Profile to save this look.');
      return;
    }
    var index = state.slideIndex;
    var key = 'lookbook-' + index;
    var wasSaved = state.savedTrends.indexOf(index) !== -1;
    state.savedTrends = wasSaved
      ? state.savedTrends.filter(function (item) { return item !== index; })
      : state.savedTrends.concat(index);
    renderLookbook();
    var request = wasSaved
      ? window.fetch(
        cfg.url + '/rest/v1/saved_trends?user_id=eq.' + encodeURIComponent(currentSession.user_id) +
          '&trend_key=eq.' + encodeURIComponent(key),
        { method: 'DELETE', headers: authHeaders(currentSession, { Prefer: 'return=minimal' }) }
      )
      : window.fetch(cfg.url + '/rest/v1/saved_trends?on_conflict=user_id,trend_key', {
        method: 'POST',
        headers: authHeaders(currentSession, {
          'Content-Type': 'application/json',
          Prefer: 'resolution=merge-duplicates,return=minimal'
        }),
        body: JSON.stringify({
          source: 'lookbook',
          title: 'Lookbook slide ' + (index + 1),
          trend_key: key,
          user_id: currentSession.user_id
        })
      });
    request.then(function (response) {
      if (!response.ok) throw new Error();
      var latest = session();
      if (!latest || latest.user_id !== currentSession.user_id) return;
      showToast(wasSaved ? 'Removed from favourites' : 'She’s saved to your favourites');
    }).catch(function () {
      var latest = session();
      if (!latest || latest.user_id !== currentSession.user_id) return;
      state.savedTrends = wasSaved
        ? state.savedTrends.concat(index)
        : state.savedTrends.filter(function (item) { return item !== index; });
      renderLookbook();
      showToast('We could not update favourites. Try again.');
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'GBP';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: currency
    }).format(Number(cents || 0) / 100);
  }

  function renderFeaturedActions() {
    var mount = root();
    if (!mount) return;
    mount.querySelector('[data-gettmi-look-save]').classList.toggle('is-active', state.savedLook);
  }

  function renderFeatured() {
    var mount = root();
    var row = state.featured;
    if (!mount || !row) return;
    var meta = row.metadata || {};
    var product = state.featuredProduct;
    var productPath = meta.tagged_product_path || row.link_path || (product ? '/products/' + product.handle : '#');
    var imagesMount = mount.querySelector('[data-gettmi-look-images]');
    imagesMount.replaceChildren();
    state.featuredImages.forEach(function (url, index) {
      var image = document.createElement('img');
      image.src = url;
      image.alt = meta.product_title || row.title || 'Featured look';
      image.loading = 'lazy';
      image.dataset.gettmiLookImage = index;
      imagesMount.appendChild(image);
    });
    state.featuredImageIndex = 0;
    setText('[data-gettmi-look-image-counter]', '1/' + Math.max(1, state.featuredImages.length));
    setText('[data-gettmi-look-page-title]', meta.page_title || 'Posts');
    setText('[data-gettmi-look-heading]', meta.post_heading || 'TRENDING NOW');
    setText('[data-gettmi-look-subtitle]', meta.post_subtitle || meta.brand || 'GETTMI');
    setText('[data-gettmi-look-kicker]', meta.brand || product && product.vendor || 'GETTMI edit');
    setText('[data-gettmi-look-title]', meta.product_title || row.title || product && product.title || 'The Muse');
    setText('[data-gettmi-look-likes]', meta.like_count || '32.1K');
    setText('[data-gettmi-look-comments]', meta.comment_count || '291');
    setText('[data-gettmi-look-saves]', meta.save_count || '2.4K');
    setText('[data-gettmi-look-vendor]', meta.brand || product && product.vendor || 'GETTMI edit');
    setText('[data-gettmi-look-caption]', meta.caption || '');
    setText('[data-gettmi-look-date]', meta.date_label || 'Today');
    var cta = mount.querySelector('[data-gettmi-look-cta]');
    cta.href = productPath;
    cta.textContent = meta.cta_label || 'GET NOW';
    var hashtags = mount.querySelector('[data-gettmi-look-hashtags]');
    hashtags.replaceChildren();
    (Array.isArray(meta.hashtags) ? meta.hashtags : ['#Shop the edit', '#Occasionwear']).forEach(function (tag) {
      var chip = document.createElement('span');
      chip.textContent = String(tag).charAt(0) === '#' ? tag : '#' + tag;
      hashtags.appendChild(chip);
    });

    var card = mount.querySelector('[data-gettmi-tagged-product]');
    var status = mount.querySelector('[data-gettmi-tagged-status]');
    if (!product) {
      card.hidden = true;
      status.hidden = false;
      status.textContent = 'Could not load this product.';
      setText('[data-gettmi-tagged-count]', '0 items');
    } else {
      card.href = productPath;
      card.hidden = false;
      status.hidden = true;
      var image = mount.querySelector('[data-gettmi-tagged-image]');
      image.src = product.featured_image || product.images && product.images[0] || '';
      image.hidden = !image.src;
      setText('[data-gettmi-tagged-title]', product.title);
      setText('[data-gettmi-tagged-vendor]', String(product.vendor || 'GETTMI').toUpperCase());
      setText('[data-gettmi-tagged-price]', formatMoney(product.price));
      setText('[data-gettmi-tagged-count]', '1 item');
    }
    renderFeaturedActions();
  }

  function activateFeatured(row, knownProduct) {
    var mount = root();
    var cfg = config();
    if (!mount || !cfg || !row) return;
    state.featuredLoadId += 1;
    var loadId = state.featuredLoadId;
    var meta = row.metadata || {};
    var heroPath = meta.hero_image_path;
    state.featured = row;
    state.featuredProduct = knownProduct || null;
    state.featuredImages = [
      heroPath ? publicUrl(cfg, row, heroPath) : publicUrl(cfg, row)
    ].concat((meta.gallery_image_paths || []).map(function (path) {
      return publicUrl(cfg, row, path);
    })).filter(Boolean);
    state.featuredImageIndex = 0;
    state.likedLook = false;
    var likeIcon = mount.querySelector('[data-gettmi-look-like] span');
    if (likeIcon) likeIcon.textContent = '♡';
    renderFeatured();
    ownerRead();
    if (knownProduct) return;

    var handle = meta.tagged_product_handle ||
      String(row.link_path || '').split('/products/')[1] || '';
    handle = String(handle).split(/[?#]/)[0];
    if (!handle) return;
    window.fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (product) {
      if (loadId !== state.featuredLoadId || state.featured !== row) return;
      state.featuredProduct = product;
      if (row === state.primaryFeatured) state.primaryFeaturedProduct = product;
      renderFeatured();
      ownerRead();
    }).catch(function () {
      if (loadId !== state.featuredLoadId || state.featured !== row) return;
      renderFeatured();
      ownerRead();
    });
  }

  function toggleLookSave() {
    if (savesGated()) return;
    var cfg = config();
    var currentSession = session();
    var row = state.featured;
    if (!cfg || !currentSession || !currentSession.user_id || !row) {
      showToast('Sign in from Profile to save this post.');
      return;
    }
    var key = featuredLookKey();
    var wasSaved = state.savedLook;
    state.savedLook = !wasSaved;
    renderFeaturedActions();
    var meta = row.metadata || {};
    var request = wasSaved
      ? window.fetch(
        cfg.url + '/rest/v1/saved_looks?user_id=eq.' + encodeURIComponent(currentSession.user_id) +
          '&look_key=eq.' + encodeURIComponent(key),
        { method: 'DELETE', headers: authHeaders(currentSession, { Prefer: 'return=minimal' }) }
      )
      : window.fetch(cfg.url + '/rest/v1/saved_looks?on_conflict=user_id,look_key', {
        method: 'POST',
        headers: authHeaders(currentSession, {
          'Content-Type': 'application/json',
          Prefer: 'resolution=merge-duplicates,return=minimal'
        }),
        body: JSON.stringify({
          look_key: key,
          payload: {
            caption: meta.caption || null,
            collection: meta.post_subtitle || meta.brand || null,
            shopPath: meta.tagged_product_path || row.link_path || null,
            title: meta.product_title || row.title || null
          },
          user_id: currentSession.user_id
        })
      });
    request.then(function (response) {
      if (!response.ok) throw new Error();
      var latest = session();
      if (!latest || latest.user_id !== currentSession.user_id) return;
      showToast(wasSaved ? 'Removed from favourites' : 'She’s saved to your favourites');
    }).catch(function () {
      var latest = session();
      if (!latest || latest.user_id !== currentSession.user_id) return;
      state.savedLook = wasSaved;
      renderFeaturedActions();
      showToast('We could not update favourites. Try again.');
    });
  }

  function renderComments(title) {
    var mount = root();
    var list = mount && mount.querySelector('[data-gettmi-comment-list]');
    if (!list) return;
    setText('[data-gettmi-comment-title]', title);
    list.replaceChildren();
    COMMENTS.forEach(function (comment) {
      var row = document.createElement('div');
      if (comment.reply) row.className = 'is-reply';
      var avatar = document.createElement('span');
      avatar.textContent = comment.author.charAt(0);
      var copy = document.createElement('p');
      var author = document.createElement('strong');
      author.textContent = comment.author;
      var text = document.createElement('span');
      text.textContent = comment.text;
      var likes = document.createElement('small');
      likes.textContent = '♡ ' + comment.likes;
      copy.append(author, text, likes);
      row.append(avatar, copy);
      list.appendChild(row);
    });
  }

  function load() {
    var mount = root();
    var cfg = config();
    if (!mount || !cfg || !cfg.url || !cfg.key) return;
    window.fetch(
      cfg.url + '/rest/v1/home_campaign_images?' +
        'select=id,surface,bucket,image_path,title,link_path,sort_order,metadata,updated_at' +
        '&surface=in.(lookbook,featured-product)&order=surface.asc,sort_order.asc',
      { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      state.slides = (rows || []).filter(function (row) {
        return row.surface === 'lookbook' && row.bucket && row.image_path;
      }).map(function (row) {
        return {
          discUrl: publicUrl(cfg, row, null, 192, 192),
          id: row.id,
          title: row.title,
          url: publicOriginalUrl(cfg, row)
        };
      });
      state.primaryFeatured = (rows || []).find(function (row) {
        return row.surface === 'featured-product';
      }) || null;
      if (!state.slides.length) return;
      if (state.primaryFeatured) {
        var floating = mount.querySelector('[data-gettmi-floating-stories]');
        mount.querySelector('[data-gettmi-lookbook-disc]').src = state.slides[0].discUrl;
        mount.querySelector('[data-gettmi-muse-disc]').src = publicUrl(cfg, state.primaryFeatured, null, 192, 192);
        floating.hidden = false;
        syncFloatingStoryVisibility();
      }
      renderLookbook();
      if (state.primaryFeatured) {
        activateFeatured(state.primaryFeatured, state.primaryFeaturedProduct);
      }
      var requestedUrl = new URL(window.location.href);
      var requestedSlide = requestedUrl.searchParams.get('gettmi_favourite_trend');
      if (requestedSlide !== null) {
        requestedUrl.searchParams.delete('gettmi_favourite_trend');
        window.history.replaceState({}, '', requestedUrl.toString());
        openSavedTrend(requestedSlide, true);
      }
    }).catch(function () {
      /* Native neutral state: floating stories stay hidden until live validation. */
    });
  }

  document.addEventListener('click', function (event) {
    var mount = root();
    if (!mount) return;
    if (event.target.closest('[data-gettmi-open-lookbook]')) {
      state.returnToFavourites = false;
      if (lookbookGated() && state.slideIndex >= lookbookOpenSlides()) {
        state.slideIndex = Math.max(0, lookbookOpenSlides() - 1);
      }
      mount.querySelector('[data-gettmi-lookbook]').hidden = false;
      lock(true);
      pushLookbookHistory();
      renderLookbook();
      return;
    }
    if (event.target.closest('[data-gettmi-close-lookbook]')) {
      if (lookbookGateIsOpen()) recordLookbookGate('close');
      closeLookbook(false);
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-gate-back]')) {
      recordLookbookGate('back');
      hideLookbookGate(true);
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-gate-keep]')) {
      recordLookbookGate('keep_browsing');
      closeLookbook(false);
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-gate-store]')) {
      var lookbookStore = event.target.closest('[data-gettmi-lookbook-gate-store]');
      if (lookbookStore.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      recordLookbookGate('store_cta_click');
      return;
    }
    if (event.target.closest('[data-gettmi-open-lookbook-full]')) {
      var fullView = mount.querySelector('[data-gettmi-lookbook-full]');
      fullView.hidden = false;
      fullView.classList.remove('is-opening');
      requestLookbookLandscape();
      window.requestAnimationFrame(function () { fullView.classList.add('is-opening'); });
      return;
    }
    if (event.target.closest('[data-gettmi-close-lookbook-full]')) {
      var openFullView = mount.querySelector('[data-gettmi-lookbook-full]');
      openFullView.hidden = true;
      openFullView.classList.remove('is-opening');
      releaseLookbookLandscape();
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-previous]')) {
      stepLookbook(-1, event.target.closest('[data-gettmi-lookbook-previous]'));
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-next]')) {
      stepLookbook(1, event.target.closest('[data-gettmi-lookbook-next]'));
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-like-button]')) {
      var isLiked = state.likedSlides.indexOf(state.slideIndex) !== -1;
      setLookbookLike(!isLiked, true, event);
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-like]')) {
      handleLookbookImageTap(event);
      return;
    }
    if (event.target.closest('[data-gettmi-lookbook-save]')) {
      toggleTrendSave();
      return;
    }
    if (event.target.closest('[data-gettmi-open-lookbook-comments]')) {
      renderComments('Lookbook comments');
      mount.querySelector('[data-gettmi-comment-sheet]').hidden = false;
      return;
    }
    if (event.target.closest('[data-gettmi-open-look-detail]')) {
      activateFeatured(state.primaryFeatured, state.primaryFeaturedProduct);
      mount.querySelector('[data-gettmi-look-detail]').hidden = false;
      lock(true);
      return;
    }
    if (event.target.closest('[data-gettmi-close-look-detail]')) {
      closeAll();
      return;
    }
    if (event.target.closest('[data-gettmi-look-like]')) {
      state.likedLook = !state.likedLook;
      event.target.closest('[data-gettmi-look-like]').querySelector('span').textContent = state.likedLook ? '♥' : '♡';
      return;
    }
    if (event.target.closest('[data-gettmi-look-save]')) {
      toggleLookSave();
      return;
    }
    if (event.target.closest('[data-gettmi-open-look-comments]')) {
      renderComments('Post comments');
      mount.querySelector('[data-gettmi-comment-sheet]').hidden = false;
      return;
    }
    if (event.target.closest('[data-gettmi-close-comments]')) {
      mount.querySelector('[data-gettmi-comment-sheet]').hidden = true;
    }
  });

  document.addEventListener('touchstart', function (event) {
    var gate = event.target.closest('[data-gettmi-lookbook-gate]');
    if (gate && event.touches.length) {
      state.lookbookGateTouchStart = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
      return;
    }
    if (!event.target.closest('[data-gettmi-lookbook-like]') || !event.touches.length) return;
    state.lookbookTouchStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY
    };
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    var gate = event.target.closest('[data-gettmi-lookbook-gate]');
    if (gate && state.lookbookGateTouchStart) {
      var gateTouch = event.changedTouches && event.changedTouches[0];
      if (!gateTouch) return;
      var gateDeltaX = gateTouch.clientX - state.lookbookGateTouchStart.x;
      var gateDeltaY = gateTouch.clientY - state.lookbookGateTouchStart.y;
      state.lookbookGateTouchStart = null;
      if (
        gateDeltaX >= 46 &&
        Math.abs(gateDeltaX) > Math.abs(gateDeltaY) * 1.35
      ) {
        recordLookbookGate('back_swipe');
        hideLookbookGate(true);
      }
      return;
    }
    if (!event.target.closest('[data-gettmi-lookbook-like]') || !state.lookbookTouchStart) return;
    var touch = event.changedTouches && event.changedTouches[0];
    if (!touch) return;
    var deltaX = touch.clientX - state.lookbookTouchStart.x;
    var deltaY = touch.clientY - state.lookbookTouchStart.y;
    state.lookbookTouchStart = null;
    if (Math.abs(deltaX) < 46 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.35) return;
    state.suppressLookbookClickUntil = Date.now() + 400;
    stepLookbook(deltaX < 0 ? 1 : -1, event.target.closest('[data-gettmi-lookbook-like]'));
  }, { passive: true });

  document.addEventListener('keydown', function (event) {
    var mount = root();
    var gate = mount && mount.querySelector('[data-gettmi-lookbook-gate]');
    if (!gate || gate.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      recordLookbookGate('close');
      closeLookbook(false);
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = [
      mount.querySelector('[data-gettmi-lookbook-gate-back]'),
      mount.querySelector('[data-gettmi-close-lookbook]'),
      mount.querySelector('[data-gettmi-lookbook-gate-store]:not([aria-disabled="true"])'),
      mount.querySelector('[data-gettmi-lookbook-gate-keep]')
    ].filter(Boolean);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (document.activeElement === gate) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }
    if (event.shiftKey && (document.activeElement === first || document.activeElement === gate)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('popstate', function (event) {
    if (state.ignoreNextLookbookPop) {
      state.ignoreNextLookbookPop = false;
      return;
    }
    if (event.state && event.state.gettmiLookbook) return;
    var mount = root();
    var lookbook = mount && mount.querySelector('[data-gettmi-lookbook]');
    if (lookbook && !lookbook.hidden) closeLookbook(true);
  });

  window.addEventListener('scroll', scheduleFloatingStoryVisibility, { passive: true });
  window.addEventListener('resize', scheduleFloatingStoryVisibility);

  document.addEventListener('scroll', function (event) {
    var slides = event.target.closest && event.target.closest('[data-gettmi-look-images]');
    if (!slides || !state.featuredImages.length) return;
    state.featuredImageIndex = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
    setText('[data-gettmi-look-image-counter]', (state.featuredImageIndex + 1) + '/' + state.featuredImages.length);
  }, true);

  document.addEventListener('gettmi:signed-in', ownerRead);
  document.addEventListener('gettmi:signed-out', ownerRead);
  document.addEventListener('gettmi:open-featured-look', function (event) {
    var mount = root();
    var row = event.detail && event.detail.row;
    if (!mount || !row) return;
    activateFeatured(row, null);
    mount.querySelector('[data-gettmi-look-detail]').hidden = false;
    lock(true);
  });
  document.addEventListener('gettmi:open-saved-trend', function (event) {
    var detail = event.detail || {};
    openSavedTrend(detail.index, detail.returnToFavourites);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
